const content = {
  calendlyUrl: "https://calendly.com/edward-lingo/30min",
  title: "Book a demo with one of our team members",
  subtitle:
    "Use the calendar below to schedule a demo. You’ll learn how Lingo can help everyone in your organization create on their own while ensuring consistency at scale.",
};

export default content;
